export default __webpack_public_path__ + "static/media/police-badge.ccac2948.svg";